import { PHONE_CODES } from '../const/phone-codes';
import { TCountryCodes } from '../models/country-code';

const defaultPhoneCode = PHONE_CODES[0].value;

const getDefaultPhoneCode = (countryCode: TCountryCodes): string =>
  PHONE_CODES.find(phoneCode => phoneCode.countryCode === countryCode)?.value || defaultPhoneCode;

export { getDefaultPhoneCode };
